import { render } from "./AiAnalysisFlowModal.vue?vue&type=template&id=742f979e"
import script from "./AiAnalysisFlowModal.vue?vue&type=script&lang=js"
export * from "./AiAnalysisFlowModal.vue?vue&type=script&lang=js"
/* custom blocks */
import block0 from "./AiAnalysisFlowModal.i18n.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Ftmp%2Fbuild_b4cdab10%2Fpackages%2Fbo%2Fsrc%2Fcomponents%2Fclaim%2Fdetails%2Fai-analysis-flow%2FAiAnalysisFlowModal.vue&external"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__